import React from "react";
import { motion } from "framer-motion";
import { Play } from "lucide-react";
import { useT } from "../i18n/LanguageContext";

export default function AdSection() {
  const { t } = useT();
  return (
    <section
      id="watch"
      data-testid="ad-section"
      className="py-24 sm:py-32 bg-[#115E59] relative overflow-hidden"
    >
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 flex items-center justify-center select-none"
      >
        <span className="font-serif italic text-[24vw] leading-none text-[#FFFFF8]/[0.04] tracking-tighter">
          watch
        </span>
      </div>
      <div className="relative max-w-5xl mx-auto px-5 sm:px-8 lg:px-12 text-center">
        <motion.div
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
        >
          <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.28em] text-[#D4AF37] font-semibold mb-5">
            <Play size={13} /> {t("watch.eyebrow")}
          </div>
          <h2 className="font-serif text-4xl sm:text-5xl font-light leading-[1.05] text-[#FFFFF8] mb-5">
            {t("watch.title.a")}{" "}
            <em className="text-[#D4AF37]">{t("watch.title.em")}</em>
          </h2>
          <p className="text-base sm:text-lg text-[#FFFFF8]/75 max-w-2xl mx-auto mb-10">
            {t("watch.sub")}
          </p>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="rounded-[2rem] overflow-hidden border border-[#D4AF37]/40 shadow-2xl"
        >
          <video
            data-testid="ad-video"
            src="/videos/soarlife-ad.mp4"
            controls
            playsInline
            preload="metadata"
            className="w-full aspect-video bg-[#0b3d39]"
          />
        </motion.div>
        <p className="mt-6 text-xs uppercase tracking-[0.22em] text-[#FFFFF8]/50">
          {t("watch.note")}
        </p>
      </div>
    </section>
  );
}
